import React from 'react'
import { createRoot } from 'react-dom/client'
import { createInertiaApp } from '@inertiajs/react'
import { Toaster } from '@/components/ui/sonner'
import { NavigationProgress } from '@/components/NavigationProgress'
import '@/styles/application.css'

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.tsx', { eager: true })
    return pages[`../pages/${name}.tsx`]
  },
  setup({ el, App, props }) {
    createRoot(el).render(
      <>
        <NavigationProgress />
        <App {...props} />
        <Toaster />
      </>
    )
  },
})
